import { useEffect, useState } from "react";
import { getPracticeMode, subscribePractice } from "@/lib/practice";
import { Radar } from "lucide-react";

/**
 * Sticky top banner shown whenever Practice Mode is ON.
 * Amber/gold, low-height, non-intrusive.
 */
export default function PracticeModeBanner() {
  const [on, setOn] = useState(getPracticeMode);
  useEffect(() => subscribePractice(setOn), []);
  if (!on) return null;
  return (
    <div
      className="sticky top-0 z-40 w-full border-b"
      style={{
        borderColor: "rgba(212,175,55,0.55)",
        background:
          "linear-gradient(90deg, rgba(212,175,55,0.18) 0%, rgba(16,185,129,0.10) 50%, rgba(212,175,55,0.14) 100%)",
        backdropFilter: "blur(8px)",
      }}
      data-testid="practice-mode-banner"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10 py-1.5 flex items-center justify-center gap-2 text-center">
        <Radar size={12} className="text-gold shrink-0" />
        <span className="text-[10px] uppercase tracking-[0.28em] font-mono-aviation text-gold">
          Practice Mode Active
        </span>
        <span className="hidden sm:inline text-[10px] text-slate-300/80 tracking-wide font-mono-aviation">
          · simulator sandbox · no live pitches will fire
        </span>
      </div>
    </div>
  );
}
